import { MembershipOfferingTypes } from "#src/utils/constants.ts";
import { moment } from "#src/utils/dateTime.ts";
import { Frequency } from "#types/code-generator.ts";

interface CalculatePricingForMembership {
  membership: {
    id: string;
    offering: {
      price?: number;
      priceLevels?: {
        number: number;
        price: number;
      }[];
      prorate?: boolean;
      type?: string;
      paymentFrequency?: Frequency;
      recurringDate?: Date;
      startDate?: Date;
      endDate?: Date;
    };
    roster: {
      firstName: string;
      lastName: string;
    }[];
  };
  startDate: Date;
}

export function calculatePricingForMembership(
  args: CalculatePricingForMembership
) {
  if (!args.membership?.offering) {
    return {
      price: 0,
      proratedPrice: 0,
    };
  }

  let price = args.membership.offering.price || 0;
  let today = moment();
  const offeringStartDate =
    args.membership.offering.startDate &&
    moment(args.membership.offering.startDate).startOf("day");
  const offeringEndDate =
    args.membership.offering.endDate &&
    moment(args.membership.offering.endDate).endOf("day");

  if (args.startDate) {
    today = moment(args.startDate);
  }

  if (args.membership.offering.priceLevels?.length > 0) {
    let members = args.membership.roster.length;

    if (!args.membership.id) {
      members = 1;
    }

    for (const p of args.membership.offering.priceLevels.sort(
      (a, b) => a.number - b.number
    )) {
      if (p.number <= members) {
        price = p.price;
      }
    }
  }

  let proratedPrice = price;

  let shouldProrate =
    args.membership.offering.prorate &&
    args.membership.offering.type !== MembershipOfferingTypes["Limited Pass"];

  if (args.membership.offering.paymentFrequency === Frequency.OneTime) {
    shouldProrate =
      shouldProrate &&
      offeringStartDate &&
      offeringStartDate.isSameOrBefore(today) &&
      offeringEndDate &&
      offeringEndDate.isSameOrAfter(today);
  }

  if (shouldProrate) {
    let date = today.clone().startOf("day");
    let endDate = date.clone().endOf("month");
    let totalNumberOfDays = date.daysInMonth();

    if (args.membership.offering.paymentFrequency === Frequency.Annual) {
      totalNumberOfDays = 365;
      endDate = date.clone().add(1, "year");

      if (args.membership.offering.recurringDate) {
        const chargeDate = moment(args.membership.offering.recurringDate).set({
          year: date.year(),
        });

        if (chargeDate.isAfter(date, "day")) {
          endDate = chargeDate;
        }

        if (chargeDate.isBefore(date, "day")) {
          endDate = chargeDate.clone().add(1, "year");
        }
      }
    }

    if (args.membership.offering.endDate) {
      const offeringEndDate = moment(args.membership.offering.endDate);

      if (offeringEndDate.isBefore(endDate, "day")) {
        endDate = offeringEndDate;
      }
    }

    let remainingNumberOfDays = Math.abs(date.diff(endDate, "day")) + 1;

    if (
      (offeringStartDate && offeringStartDate.isBefore(today, "day")) ||
      !offeringStartDate
    ) {
      // console.log("totalNumberOfDays", totalNumberOfDays);
      // console.log("startDate", date.format());
      // console.log("endDate", endDate.format());
      // console.log("remainingNumberOfDays", remainingNumberOfDays);

      let pricePerDay = price / totalNumberOfDays;

      if (remainingNumberOfDays < totalNumberOfDays) {
        proratedPrice = pricePerDay * remainingNumberOfDays;
      }
    }
  }

  let displayPrice = price;

  if (
    offeringStartDate &&
    offeringStartDate.isAfter(today, "day") &&
    args.membership.offering.paymentFrequency !== Frequency.OneTime
  ) {
    price = 0;
    proratedPrice = 0;
  }

  // console.log("price", price);
  // console.log("proratedPrice", proratedPrice);
  // console.log("displayPrice", displayPrice);

  return {
    price: Math.ceil(price),
    proratedPrice: Math.ceil(proratedPrice),
    displayPrice: Math.ceil(displayPrice),
  };
}
